import smLandingAppstoreApp1WhatsNew from './sm-landing-appstore-app-1-whats-new';



export default smLandingAppstoreApp1WhatsNew;



// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/sm-landing-appstore-app-1-whats-new/index.js